/**
 * listasBus — canal interno de eventos para sincronización inmediata de listas.
 *
 * Al confirmar una venta en POSTerminal, se emite un evento con los datos
 * de la jugada. VendedorListasPage escucha y aplica un refresh inmediato
 * (optimistic UI) sin esperar el ciclo de polling de 5s.
 *
 * NO usa WebSocket. NO toca backend. Es solo pub/sub en memoria del proceso.
 */

export interface VentaEvento {
  sorteo_id: string;
  tipo_id: string;          // NORMAL | REVENTADO | MEGA | MONAZOS | FECHAS | PARLEY
  jugadas: Array<{
    num1: string;
    num2?: string | null;
    monto: number;
  }>;
}

const bus = new EventTarget();
const EVENTO = 'venta-confirmada';

export const emitirVenta = (datos: VentaEvento): void => {
  bus.dispatchEvent(new CustomEvent(EVENTO, { detail: datos }));
};

export const onVenta = (cb: (datos: VentaEvento) => void): (() => void) => {
  const handler = (e: Event) => cb((e as CustomEvent<VentaEvento>).detail);
  bus.addEventListener(EVENTO, handler);
  return () => bus.removeEventListener(EVENTO, handler);
};
